if (!customElements.get('rendi-order-returns')) {
  class RendiOrderReturns extends HTMLElement {
    constructor() {
      super();
      this.handleChangeBound = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.name = this.dataset.name || 'returns';
      this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
      this.items = Array.from(this.querySelectorAll('[data-return-item]'));

      this.checkboxes.forEach((cb) => {
        cb.addEventListener('change', this.handleChangeBound);
      });

      this.updateUi();
    }

    disconnectedCallback() {
      this.checkboxes?.forEach((cb) => {
        cb.removeEventListener('change', this.handleChangeBound);
      });
    }

    handleChange() {
      this.updateUi();
      this.dispatchValue();
    }

    getSelectedItems() {
      return this.checkboxes
        .filter((cb) => cb.checked)
        .map((cb) => ({
          sku: cb.dataset.sku,
          title: cb.dataset.title,
          price: Number(cb.dataset.price),
          cashback: Number(cb.dataset.cashback),
          order_name: cb.dataset.orderName,
          order_id: cb.dataset.orderId,
          variant_id: cb.dataset.variantId,
          line_item_key: cb.dataset.lineItemKey
        }));
    }

    updateUi() {
      this.items.forEach((item) => {
        const cb = item.querySelector('input[type="checkbox"]');
        item.classList.toggle('is-selected', Boolean(cb?.checked));
      });
    }

    dispatchValue() {
      this.dispatchEvent(new CustomEvent('rendi:field-change', {
        bubbles: true,
        detail: {
          name: this.name,
          value: this.getSelectedItems()
        }
      }));
    }

    setSelected(items, options = {}) {
      if (!Array.isArray(items)) return;

      const keys = new Set(
        items.map((i) => `${i.order_id}-${i.variant_id}`)
      );

      this.checkboxes.forEach((cb) => {
        const key = `${cb.dataset.orderId}-${cb.dataset.variantId}`;
        cb.checked = keys.has(key);
      });

      this.updateUi();

      if (!options.silent) {
        this.dispatchValue();
      }
    }

    clear(options = {}) {
      this.checkboxes.forEach((cb) => {
        cb.checked = false;
      });

      this.updateUi();

      if (!options.silent) {
        this.dispatchValue();
      }
    }
  }

  customElements.define('rendi-order-returns', RendiOrderReturns);
}
